import {
  CancelLicenseSubscriptionDTO,
  LicenseCancellationReason,
} from "@shaarp/common";

/**
 * Body of the cancellation request. The reason and the comment are sent only
 * when filled in, so a cancellation without feedback posts exactly what it
 * posted before they existed.
 */
export const buildCancelLicenseSubscriptionBody = ({
  frequency,
  reason,
  comment,
}: {
  frequency: CancelLicenseSubscriptionDTO["frequency"];
  reason: LicenseCancellationReason | null;
  comment: string;
}): CancelLicenseSubscriptionDTO => {
  const trimmedComment = comment.trim();
  return {
    frequency,
    confirmed: true,
    ...(reason ? { reason } : {}),
    ...(trimmedComment ? { comment: trimmedComment } : {}),
  };
};
